import { useCallback, useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import { completePlaidConnectionRepair, createPlaidUpdateLinkToken } from "../lib/financeConnections";

const TOKEN_KEY="famdashfun_plaid_update_token";
const CONNECTION_KEY="famdashfun_plaid_update_connection";
const isOAuthReturn=()=>new URLSearchParams(window.location.search).has("oauth_state_id");

export function PlaidReconnectButton({householdId,connectionId,institutionName,onReconnected}:{householdId:string;connectionId:string;institutionName:string;onReconnected?:()=>void}){
  const returning=isOAuthReturn()&&sessionStorage.getItem(CONNECTION_KEY)===connectionId;
  const [token,setToken]=useState<string|null>(()=>returning?sessionStorage.getItem(TOKEN_KEY):null);
  const [status,setStatus]=useState<"idle"|"preparing"|"linking"|"syncing"|"success"|"error">("idle");
  const [message,setMessage]=useState("");

  const clearReturn=()=>{
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(CONNECTION_KEY);
    if(isOAuthReturn())window.history.replaceState({},document.title,window.location.pathname);
  };

  const onSuccess=useCallback(async()=>{
    setStatus("syncing");setMessage("Refreshing missed data…");
    try{
      await completePlaidConnectionRepair(householdId,connectionId);
      clearReturn();setToken(null);setStatus("success");setMessage("Reconnected and refreshed.");onReconnected?.();
    }catch(error){setStatus("error");setMessage(error instanceof Error?error.message:"The connection could not be refreshed.");}
  },[householdId,connectionId,onReconnected]);

  const {open,ready,error}=usePlaidLink({
    token,
    onSuccess,
    receivedRedirectUri:returning?window.location.href:undefined,
    onExit:exit=>{if(exit){setStatus("error");setMessage(exit.display_message||`${institutionName} login was not completed.`);}else if(status==="linking"){setStatus("idle");}}
  });

  useEffect(()=>{if(token&&ready){setStatus("linking");open();}},[token,ready,open]);
  useEffect(()=>{if(error){setStatus("error");setMessage("Plaid Link could not load. Try again.");}},[error]);

  async function begin(){
    setStatus("preparing");setMessage(`Opening ${institutionName} securely…`);
    try{
      const result=await createPlaidUpdateLinkToken(householdId,connectionId);
      sessionStorage.setItem(TOKEN_KEY,result.linkToken);sessionStorage.setItem(CONNECTION_KEY,connectionId);setToken(result.linkToken);
    }catch(error){setStatus("error");setMessage(error instanceof Error?error.message:"Could not start the secure login repair.");}
  }

  const busy=["preparing","linking","syncing"].includes(status);
  return <span className="finance-investment-upgrade finance-reconnect">
    <button
      type="button"
      onClick={()=>void begin()}
      disabled={busy}
      style={{border:0,background:"transparent",padding:0,borderRadius:0,color:"#2f6e8e",fontSize:".72rem",fontWeight:800,textDecoration:"underline",textUnderlineOffset:"2px",cursor:busy?"wait":"pointer"}}
    >{busy?(status==="syncing"?"Refreshing…":"Opening Plaid…"):"Reconnect"}</button>
    {message&&<small role="status" aria-live="polite">{message}</small>}
  </span>;
}
